<template>
    <div class="item" :class="{ 'item-up': dataValue.showUp }">
        <div class="title">{{ dataValue.messageTitle }}</div>
        <div class="flex">
            <div class="item-content" ref="content" :id="'content' + id">
                <div class="icon" v-if="showBtn" @click="xxItemIconClick()"></div>
                {{ dataValue.messageBody }}
            </div>
            <div class="contentCopy" ref="contentCopy" :id="'contentCopy' + id">
                {{ dataValue.messageBody }}
            </div>
        </div>


        <div class="time">{{ dataValue.pushTime }}</div>
    </div>
</template>

<script>
export default {
    props: ["dataValue", "dataIndex", "id"],
    data() {
        return {
            showBtn: false,
        }
    },
    mounted() {
        this.$forceUpdate();
        const el = this.$refs.content

        const elCopy = this.$refs.contentCopy

        // const el = document.getElementById('content' + this.id)
        // const elCopy = document.getElementById('contentCopy' + this.id)
        // console.log(el, elCopy)
        if (el && elCopy) {
            this.showBtn = el.clientWidth < elCopy.clientWidth
            // console.log(el.offsetWidth, elCopy.offsetWidth)
        }


    },
    methods: {
        xxItemIconClick() {
            this.$emit("iconChange", this.dataIndex)
        }
    },
}
</script>

<style lang="scss" scoped>
.item {
    position: relative;
    width: 98.5%;
    box-sizing: border-box;
    padding: 0.15rem 0.25rem 0.2125rem 0.225rem;
    border-radius: 0.05rem;
    background: rgba(237, 237, 237, 0.5);
    margin-bottom: 0.125rem;

    &>div {
        text-align: left;
    }

    .title {
        font-size: 0.2rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #454545;
    }

    .item-content {
        margin-top: 0.1375rem;
        margin-bottom: 0.1375rem;
        font-size: 0.175rem;
        line-height: 1.5;
        font-family: Microsoft YaHei;
        font-weight: 400;
        max-height: 18px;
        color: #454545;
        overflow: hidden;

        max-height: 9999px;

        &::before {
            content: '';
            float: right;
            width: 0px;
            height: calc(100% - 0.125rem);
        }

        .icon {
            cursor: pointer;
            float: right;
            width: 0.15rem;
            height: 0.1125rem;
            background: url('~@/assets/image/home/XL.png') no-repeat;
            background-size: 100% 100%;
            transition: all 0.5s;
            clear: both;
            transform: rotate(180deg);
        }
    }

    .contentCopy {
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        display: inline-block;
        margin-top: 0.1375rem;
        margin-bottom: 0.1375rem;
        font-size: 0.175rem;
        line-height: 1.5;
        font-family: Microsoft YaHei;
        font-weight: 400;
        max-height: 18px;
        color: #454545;
        color: red;
        white-space: nowrap;
        opacity: 0;
    }

    .time {
        color: #939393;
    }
}

.item-up {
    .item-content {
        text-align: justify;

        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        max-height: 18px;

        .icon {
            transform: rotate(0deg);
        }
    }
}

.item:last-child {
    margin-bottom: 0;
}
</style>